/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { createFilteredDataSelector } from '../../create-filtered-data/create-filtered-data.selector';
import { createSearchFilteredDataIdsSelector } from '../create-search-filtered-data-ids-selector/create-search-filtered-data-ids.selector';

export const createIsIsEmptyBySearchSelector = (filterInstanceId: string) =>
  createSelector(createSearchFilteredDataIdsSelector(filterInstanceId), createFilteredDataSelector(filterInstanceId), (searchFilteredDataIds, filteredDataIds) => {
    if (!searchFilteredDataIds) {
      return false;
    }
    
    if (!filteredDataIds.length && searchFilteredDataIds) {
      return true;
    }

    return false;
  });
